import HttpClient from '@/common/boot/HttpClient'
import router from "@/router";

const listarUsuarios = async ({ commit }, payload) => {

  commit('BUSCANDO', true);
  commit('INSERIR_LISTA_USUARIOS', []);

  const params = {
    trashed: payload?.exibirItensDeletados ? true : '',
    sem_modulo: payload?.semModulo ? true : ''
  };

  try {
    const response = await HttpClient.get('/usuarios', {
      params
    });
    commit('INSERIR_LISTA_USUARIOS', response.data.data)
    return response;
  } finally {
    commit('BUSCANDO', false);
  }
}

const listarProvedores = async ({ commit }) => {
  commit('BUSCANDO', true);

  try {
    const response = await HttpClient.get('/ctrl-provedores');

    const provedores = response.data.data;

    commit('INSERIR_LISTA_PROVEDORES', provedores);

    return provedores;

  } finally {
    commit('BUSCANDO', false);
  }
};

const sincronizarProvedores = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  try {
    const response = await HttpClient.post(
      `/usuarios/${payload.id}/provedores/sincronizar`,
      payload
    );
    return response;
  } finally {
    commit('BUSCANDO', false);
  }
};

const listarUsuariosComPaginacao = async ({ commit }, payload) => {

  commit('BUSCANDO', true);

  return HttpClient.post('/app/users-dados', payload).then(response => {
    commit('INSERIR_LISTA_USUARIOS', response.data.data)
    return response;
  }).finally(() => {
    commit('BUSCANDO', false);
  });

}

const salvarUsuario = async ({ commit }, payload) => {

  commit('BUSCANDO', true);

  return await HttpClient.post('/usuarios', payload).then(response => {
    commit('INSERIR_USUARIO', response.data.data)
    commit('INSERIR_USUARIO_PERFIL', response.data.data)
    if (response) {
      router.push({ name: 'usuario-modulos', params: { usuario: response.data.data.id } });
    }
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const recuperarUsuario = ({ commit, state }, payload) => {

  const usuario = state.items.filter(usuario => usuario.id === payload.id)

  if (usuario.length) {
    commit('INSERIR_USUARIO_SELECIONADO', ...usuario)
    return true
  }

  return false
}

const atualizarUsuario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  try {
    const response = await HttpClient.put(`/usuarios/${payload.id}`, payload);

    commit('ATUALIZAR_USUARIO', response.data.data);

    return response;
  } finally {
    commit('BUSCANDO', false);
  }
};

const deletarUsuario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.delete(`/usuarios/${payload.id}`).then(response => {
    commit('DELETAR_USUARIO', payload)
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    })

}

const restaurarUsuario = ({ commit }, payload) => {

  commit('BUSCANDO', true);

  HttpClient.post(`/usuarios/${payload}/restaurar/`).then(response => {
    console.log(response);
    commit('ATUALIZAR_USUARIO', response.data.data)
    return response;
  }).finally(() => {
    commit('BUSCANDO', false);
  });
}


const getUsuario = ({ commit }, payload) => {

  commit('BUSCANDO', true);

  return HttpClient.get(`/usuarios/${payload}`).then(response => {
    commit('INSERIR_USUARIO_PERFIL', response.data.data)
    return response;
  }).finally(() => {
    commit('BUSCANDO', false);
  });
}

const alterarSenhaUsuario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  try {
    const response = await HttpClient.post(`/usuarios/${payload.id}/alterar-senha`, {
      senha_atual: payload.senha_atual,
      nova_senha: payload.nova_senha
    });
    return response;
  } catch (error) {
    console.error('Erro ao alterar senha:', error);
    throw error;
  } finally {
    commit('BUSCANDO', false);
  }
}

////////////////////////////////////////////////////
// const getTarefasUsuario = ({ commit }, payload) => {

//   commit('BUSCANDO', true);

//   HttpClient.get(`/gestao-producao/acl-perfis/${payload}/tarefas-usuario`).then(response => {
//       commit('INSERIR_TAREFA_USUARIO_PERFIL', response.data)
//       return response;
//   }).finally(() => {
//       commit('BUSCANDO', false);
//   });
// }

////////////////////////////////////////////////////
// const getRegionaisUsuario = ({ commit }, payload) => {

//   commit('BUSCANDO', true);

//   HttpClient.get(`/gestao-producao/acl-perfis/${payload}/regionais-usuario`).then(response => {
//       commit('INSERIR_REGIONAL_USUARIO_PERFIL', response.data)
//       return response;
//   }).finally(() => {
//       commit('BUSCANDO', false);
//   });
// }

////////////////////////////////////////////////////
// const getEquipesUsuario = ({ commit }, payload) => {

//   commit('BUSCANDO', true);

//   HttpClient.get(`/gestao-producao/ctrl-equipes/${payload}/listar-equipes`).then(response => {
//       commit('INSERIR_EQUIPES_USUARIO', response.data)
//       return response;
//   }).finally(() => {
//       commit('BUSCANDO', false);
//   });
// }

// const atualizarContatosUsuario = async({ commit }, payload) => {
//   commit('LOADING', true);

//   return await HttpClient.post(`/app/users/${payload.id}/atualizar-contatos`, payload).then(response => {
//     commit('ATUALIZAR_CONTATOS_USUARIO', payload);
//     return response;
//   })
//   .finally(() => {
//     commit('LOADING', false);
//   });
// }

// const getConfiguracaoUsuario = ({ commit }, payload) => {

//   commit('BUSCANDO', true);

//   HttpClient.get(`/gestao-producao/ctrl-configuracao-usuarios/configuracao-usuario`, payload).then(response => {
//       commit('INSERIR_CONFIGURACAO_USUARIO', response.data.data)
//       return response;
//   }).finally(() => {
//       commit('BUSCANDO', false);
//   });
// }

// const atualizaNotificacaoAlarme = async({ commit }, payload) => {
//   commit('LOADING', true);

//   return await HttpClient.post(`/gestao-producao/ctrl-configuracao-usuarios/registra-configuracao`, payload).then(response => {
//     commit('ATUALIZAR_CONFIGURACAO_ALARME', payload);
//     return response;
//   })
//   .finally(() => {
//     commit('LOADING', false);
//   });
// }


const importarUsuarios = async ({ commit }, formData) => {
  commit('BUSCANDO', true);
  try {
    return await HttpClient.post('/usuarios/importar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  } finally {
    commit('BUSCANDO', false);
  }
};

const verificarStatusImportacao = async (_store, jobId) => {
  return HttpClient.get(`/usuarios/importar/${jobId}/status`);
};

const baixarModeloImportacao = async () => {
  const response = await HttpClient.get('/usuarios/modelo', { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'modelo_importacao_usuarios.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export {
  listarUsuarios,
  salvarUsuario,
  recuperarUsuario,
  atualizarUsuario,
  deletarUsuario,
  restaurarUsuario,
  getUsuario,
  alterarSenhaUsuario,
  listarUsuariosComPaginacao,
  listarProvedores,
  sincronizarProvedores,
  importarUsuarios,
  verificarStatusImportacao,
  baixarModeloImportacao,
}
